import { ColDef, ValueGetterParams } from "ag-grid-community";
import { getCreditType } from "../utils/getCreditType";
import Typo from "@/src/components/atom/Typo";
import { getFormattedTimezoneDateWithOffset } from "@/src/hooks/useCompanyLocalDate";
import DATE_FORMAT_STRINGS from "@/src/constant/dateFormat";

export const expirationScheduledColumns = [
  {
    headerClass: "ag-right-aligned-cell ag-header-hide",
    cellStyle: { textAlign: "center" },
    field: "expiredAt",
    flex: 1,
    minWidth: 150,
    cellRenderer: (params: ValueGetterParams) => {
      const gmtOffset = params.data?.gmtOffset;

      return params.data.expiredAt ? (
        <Typo typoType="b9r">
          {getFormattedTimezoneDateWithOffset({
            date: params.data.expiredAt,
            gmtOffset,
            format: DATE_FORMAT_STRINGS.YYYY_MM_DD,
          })}
        </Typo>
      ) : (
        "-"
      );
    },
    sortable: true,
  },
  {
    headerClass: "ag-right-aligned-cell ag-header-hide",
    cellStyle: { textAlign: "center" },
    field: "creditType",
    flex: 1,
    minWidth: 150,
    cellRenderer: (params: ValueGetterParams) => {
      const t = params.data.t;

      return params.data?.creditType ? (
        <Typo typoType="b9r">{t(getCreditType(params.data.creditType))}</Typo>
      ) : (
        "-"
      );
    },
    sortable: false,
  },
  {
    headerClass: "ag-right-aligned-cell ag-header-hide",
    cellStyle: { textAlign: "center" },
    field: "consumptionPredictedCredit",
    flex: 1,
    minWidth: 150,
    cellRenderer: (params: ValueGetterParams) => {
      const availableCredit = params.data?.availableCredit;
      return availableCredit ? (
        <Typo typoType="b9r">{availableCredit.toLocaleString("ko-KR")}</Typo>
      ) : (
        "-"
      );
    },
    sortable: false,
  },
] as ColDef[];
